var map = {
	"./bike_blur.jpg": 5298,
	"./car_blur.jpg": 1208,
	"./christmas_tree_blur.jpg": 8242,
	"./gummy_bear_blur.jpg": 2238,
	"./helicopter_blur.jpg": 4610,
	"./newspaper_blur.jpg": 3979,
	"./press_blur.jpg": 4780,
	"./tape_blur.jpg": 229,
	"./thermos_blur.jpg": 621,
	"./toothpaste_blur.jpg": 388
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2667;